import React from 'react';
import CalendarPage from './CalendarPage';
import './CalendarModal.css';

const CalendarModal = ({ isOpen, onClose, currentUser, initialDate, initialView, refreshTrigger }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="calendar-modal-backdrop" 
      onClick={handleBackdropClick}
    >
      <div className="calendar-modal-container">
        <div className="calendar-modal-header">
          <h4 className="calendar-modal-title thai-text">
            <i className="fas fa-calendar-alt me-2"></i>
            ปฏิทินวันที่กำหนด
          </h4>
          <button 
            type="button" 
            className="calendar-modal-close-btn"
            onClick={onClose}
            aria-label="ปิดหน้าต่าง"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="calendar-modal-body">
          <CalendarPage currentUser={currentUser} initialDate={initialDate} initialView={initialView} refreshTrigger={refreshTrigger} />
        </div>
      </div>
    </div>
  );
};

export default CalendarModal;